module.exports = __webpack_public_path__ + "static/media/moveModal.c0a6b000.jpg";